import {addressHasChanges, createNewAddress, resetAddressObject} from "@/scripts/Common/helpers";
import type {User} from "@/components/users/scripts/types";

const createEmptyUser = () => {
    const user: User = {
        id: 0,
        firstName: "",
        lastName: "",
        email: "",
        paycardNumber: "",
        phoneNumber: "",
        addressId: 0,
        address: createNewAddress()
    }

    return user;
}

const resetUserObject = (originalObject: User, changedObject: User) => {
    changedObject.id = originalObject.id;
    changedObject.firstName = originalObject.firstName;
    changedObject.lastName = originalObject.lastName;
    changedObject.email = originalObject.email;
    changedObject.paycardNumber = originalObject.paycardNumber;
    changedObject.phoneNumber = originalObject.phoneNumber;
    changedObject.addressId = originalObject.addressId;
    resetAddressObject(originalObject.address, changedObject.address);
}

const userHasChanges = (originalObject: User, changedObject: User) => {
    return changedObject.id !== originalObject.id
    || changedObject.firstName !== originalObject.firstName
    || changedObject.lastName !== originalObject.lastName
    || changedObject.email !== originalObject.email
    || changedObject.paycardNumber !== originalObject.paycardNumber
    || changedObject.phoneNumber !== originalObject.phoneNumber
    || changedObject.addressId !== originalObject.addressId
    || addressHasChanges(originalObject.address, changedObject.address);
}

export {
    createEmptyUser,
    resetUserObject,
    userHasChanges
}
